import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import { useCombobox } from 'downshift';
import React, { useRef, useState, useMemo, useEffect, useCallback } from 'react';
import { useMergeRefs } from 'use-callback-ref';
import { Input } from '../../../Input/Input.es.js';
import { IconButton } from '../../../IconButton/IconButton.es.js';
import '../../../../assets/icons/custom/CheckIcon.es.js';
import '../../../../assets/icons/generated/filled/AndroidFilled.es.js';
import '../../../../assets/icons/generated/filled/AppleFilled.es.js';
import '../../../../assets/icons/generated/filled/ArrowForwardFilled.es.js';
import '../../../../assets/icons/generated/filled/CameraAddFilled.es.js';
import '../../../../assets/icons/generated/filled/CameraFilled.es.js';
import '../../../../assets/icons/generated/filled/CdPauseFilled.es.js';
import '../../../../assets/icons/generated/filled/CheckCircleFilled.es.js';
import '../../../../assets/icons/generated/filled/CommentsFilled.es.js';
import '../../../../assets/icons/generated/filled/CommentsTextFilled.es.js';
import '../../../../assets/icons/generated/filled/CreditCardFilled.es.js';
import '../../../../assets/icons/generated/filled/CrownFilled.es.js';
import '../../../../assets/icons/generated/filled/DownloadCircleFilled.es.js';
import '../../../../assets/icons/generated/filled/FacebookFilled.es.js';
import '../../../../assets/icons/generated/filled/FolderFilled.es.js';
import '../../../../assets/icons/generated/filled/HeartFilled.es.js';
import '../../../../assets/icons/generated/filled/HelpFilled.es.js';
import '../../../../assets/icons/generated/filled/InfoFilled.es.js';
import '../../../../assets/icons/generated/filled/InstagramFilled.es.js';
import '../../../../assets/icons/generated/filled/KebabFilled.es.js';
import '../../../../assets/icons/generated/filled/LightningFilled.es.js';
import '../../../../assets/icons/generated/filled/LinkFilled.es.js';
import '../../../../assets/icons/generated/filled/LinkedinFilled.es.js';
import '../../../../assets/icons/generated/filled/LockFilled.es.js';
import '../../../../assets/icons/generated/filled/MasterFilled.es.js';
import '../../../../assets/icons/generated/filled/MeatballsFilled.es.js';
import '../../../../assets/icons/generated/filled/PauseFilled.es.js';
import '../../../../assets/icons/generated/filled/PlayFilled.es.js';
import '../../../../assets/icons/generated/filled/RecordFilled.es.js';
import '../../../../assets/icons/generated/filled/RedditFilled.es.js';
import '../../../../assets/icons/generated/filled/ReleasesFilled.es.js';
import '../../../../assets/icons/generated/filled/RemoveFilled.es.js';
import '../../../../assets/icons/generated/filled/ReplyFilled.es.js';
import '../../../../assets/icons/generated/filled/SpotifyFilled.es.js';
import '../../../../assets/icons/generated/filled/StarFilled.es.js';
import '../../../../assets/icons/generated/filled/StarHalfFilled.es.js';
import '../../../../assets/icons/generated/filled/StopFilled.es.js';
import '../../../../assets/icons/generated/filled/TwitterFilled.es.js';
import '../../../../assets/icons/generated/filled/UsersFilled.es.js';
import '../../../../assets/icons/generated/filled/VolumeFilled.es.js';
import '../../../../assets/icons/generated/filled/VolumeMuteFilled.es.js';
import '../../../../assets/icons/generated/filled/WarningFilled.es.js';
import '../../../../assets/icons/generated/filled/WindowsFilled.es.js';
import '../../../../assets/icons/generated/filled/XFilled.es.js';
import '../../../../assets/icons/generated/filled/YoutubeFilled.es.js';
import '../../../../assets/icons/generated/outlined/CalendarOutlined.es.js';
import '../../../../assets/icons/generated/outlined/AddFileOutlined.es.js';
import '../../../../assets/icons/generated/outlined/AddOutlined.es.js';
import '../../../../assets/icons/generated/outlined/AddReleaseOutlined.es.js';
import '../../../../assets/icons/generated/outlined/AddToCollectionOutlined.es.js';
import '../../../../assets/icons/generated/outlined/AddSongOutlined.es.js';
import '../../../../assets/icons/generated/outlined/AlbumOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ArchiveOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ArrowBackOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ArrowForwardOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ArrowDownOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ArrowUpOutlined.es.js';
import '../../../../assets/icons/generated/outlined/AttachmentOutlined.es.js';
import '../../../../assets/icons/generated/outlined/AudioLinesOutlined.es.js';
import '../../../../assets/icons/generated/outlined/BassOutlined.es.js';
import '../../../../assets/icons/generated/outlined/BellOutlinedOff.es.js';
import '../../../../assets/icons/generated/outlined/BellOutlined.es.js';
import '../../../../assets/icons/generated/outlined/BentoOutlined.es.js';
import '../../../../assets/icons/generated/outlined/BlocksOutlined.es.js';
import '../../../../assets/icons/generated/outlined/CameraOffOutlined.es.js';
import '../../../../assets/icons/generated/outlined/CameraOutlined.es.js';
import '../../../../assets/icons/generated/outlined/CancelOutlined.es.js';
import CaretDownOutlined from '../../../../assets/icons/generated/outlined/CaretDownOutlined.es.js';
import '../../../../assets/icons/generated/outlined/CaretLeftOutlined.es.js';
import '../../../../assets/icons/generated/outlined/CaretRightOutlined.es.js';
import '../../../../assets/icons/generated/outlined/CaretUpOutlined.es.js';
import '../../../../assets/icons/generated/outlined/CdArrowOutlined.es.js';
import '../../../../assets/icons/generated/outlined/CdTimerOutlined.es.js';
import '../../../../assets/icons/generated/outlined/CheckOutlined.es.js';
import '../../../../assets/icons/generated/outlined/CheckCircleOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ClockHistoryOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ClockOutlined.es.js';
import CloseOutlined from '../../../../assets/icons/generated/outlined/CloseOutlined.es.js';
import '../../../../assets/icons/generated/outlined/CloudUploadOutlined.es.js';
import '../../../../assets/icons/generated/outlined/CogOutlined.es.js';
import '../../../../assets/icons/generated/outlined/CommentMusicNoteOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ComputerDesktopOutlined.es.js';
import '../../../../assets/icons/generated/outlined/CopyOutlined.es.js';
import '../../../../assets/icons/generated/outlined/CouponOutlined.es.js';
import '../../../../assets/icons/generated/outlined/CreditCardOutlined.es.js';
import '../../../../assets/icons/generated/outlined/CrownOutlined.es.js';
import '../../../../assets/icons/generated/outlined/DeliveryOutlined.es.js';
import '../../../../assets/icons/generated/outlined/DiskOutlined.es.js';
import '../../../../assets/icons/generated/outlined/DownloadOutlined.es.js';
import '../../../../assets/icons/generated/outlined/DragOutlined.es.js';
import '../../../../assets/icons/generated/outlined/DrumsOutlined.es.js';
import '../../../../assets/icons/generated/outlined/EditOutlined.es.js';
import '../../../../assets/icons/generated/outlined/EmojiOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ExpandOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ExternalLinkOutlined.es.js';
import '../../../../assets/icons/generated/outlined/FeatherOutlined.es.js';
import '../../../../assets/icons/generated/outlined/FileOutlined.es.js';
import '../../../../assets/icons/generated/outlined/FileTextOutlined.es.js';
import '../../../../assets/icons/generated/outlined/FilterOutlined.es.js';
import '../../../../assets/icons/generated/outlined/FiltersOutlined.es.js';
import '../../../../assets/icons/generated/outlined/FlagOutlined.es.js';
import '../../../../assets/icons/generated/outlined/FolderMusic.es.js';
import '../../../../assets/icons/generated/outlined/FolderOutlined.es.js';
import '../../../../assets/icons/generated/outlined/GiftOutlined.es.js';
import '../../../../assets/icons/generated/outlined/GlobeOutlined.es.js';
import '../../../../assets/icons/generated/outlined/GrandPianoOutlined.es.js';
import '../../../../assets/icons/generated/outlined/GridOutlined.es.js';
import '../../../../assets/icons/generated/outlined/GuitarOutlined.es.js';
import '../../../../assets/icons/generated/outlined/HandCoinsOutlined.es.js';
import '../../../../assets/icons/generated/outlined/HandOutlined.es.js';
import '../../../../assets/icons/generated/outlined/HandshakeOutlined.es.js';
import '../../../../assets/icons/generated/outlined/HeadphonesAddOutlined.es.js';
import '../../../../assets/icons/generated/outlined/HeadphonesCheckedOutlined.es.js';
import '../../../../assets/icons/generated/outlined/HeadphonesOutlined.es.js';
import '../../../../assets/icons/generated/outlined/HeartOutlined.es.js';
import '../../../../assets/icons/generated/outlined/HelpOutlined.es.js';
import '../../../../assets/icons/generated/outlined/HideOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ImageOutlined.es.js';
import '../../../../assets/icons/generated/outlined/InfoOutlined.es.js';
import '../../../../assets/icons/generated/outlined/KeyOutlined.es.js';
import '../../../../assets/icons/generated/outlined/KeyboardOutlined.es.js';
import '../../../../assets/icons/generated/outlined/LeaveLeftOutlined.es.js';
import '../../../../assets/icons/generated/outlined/LeaveOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ListOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ListUnorderedOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ListMusicNoteOutlined.es.js';
import '../../../../assets/icons/generated/outlined/LockOutlined.es.js';
import '../../../../assets/icons/generated/outlined/LogoOutlined.es.js';
import '../../../../assets/icons/generated/outlined/LoopOutlined.es.js';
import '../../../../assets/icons/generated/outlined/MagicWandOutlined.es.js';
import '../../../../assets/icons/generated/outlined/MailOutlined.es.js';
import '../../../../assets/icons/generated/outlined/MenuInvertedOutlined.es.js';
import '../../../../assets/icons/generated/outlined/MenuOutlined.es.js';
import '../../../../assets/icons/generated/outlined/MessageCircleHeartOutlined.es.js';
import '../../../../assets/icons/generated/outlined/MicrophoneOffOutlined.es.js';
import '../../../../assets/icons/generated/outlined/MicrophoneOutlined.es.js';
import '../../../../assets/icons/generated/outlined/MinimizeOutlined.es.js';
import '../../../../assets/icons/generated/outlined/MinusOutlined.es.js';
import '../../../../assets/icons/generated/outlined/MobilePhoneOutlined.es.js';
import '../../../../assets/icons/generated/outlined/MoneyOutlined.es.js';
import '../../../../assets/icons/generated/outlined/MonitorOffOutlined.es.js';
import '../../../../assets/icons/generated/outlined/MonitorOutlined.es.js';
import '../../../../assets/icons/generated/outlined/MoveToFolderOutlined.es.js';
import '../../../../assets/icons/generated/outlined/MusicNoteOff.es.js';
import '../../../../assets/icons/generated/outlined/MusicNote.es.js';
import '../../../../assets/icons/generated/outlined/NetworkOutlined.es.js';
import '../../../../assets/icons/generated/outlined/NoteOutlined.es.js';
import '../../../../assets/icons/generated/outlined/OrderOutlined.es.js';
import '../../../../assets/icons/generated/outlined/PackOutlined.es.js';
import '../../../../assets/icons/generated/outlined/PaperPlaneOutlined.es.js';
import '../../../../assets/icons/generated/outlined/PencilOutlined.es.js';
import '../../../../assets/icons/generated/outlined/PencilPaperOutlined.es.js';
import '../../../../assets/icons/generated/outlined/PercentageOutlined.es.js';
import '../../../../assets/icons/generated/outlined/PhoneOutlined.es.js';
import '../../../../assets/icons/generated/outlined/PianoOutlined.es.js';
import '../../../../assets/icons/generated/outlined/PlaylistOutlined.es.js';
import '../../../../assets/icons/generated/outlined/PlugOutlined.es.js';
import '../../../../assets/icons/generated/outlined/PlusOutlined.es.js';
import '../../../../assets/icons/generated/outlined/PreserverOutlined.es.js';
import '../../../../assets/icons/generated/outlined/PriceTagOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ProductBlogOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ProductNetworkOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ProductPluginsOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ProductProjectsOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ProductReleasesOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ProductSamplesOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ProfileOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ProviderOutlined.es.js';
import '../../../../assets/icons/generated/outlined/QuoteOutlined.es.js';
import '../../../../assets/icons/generated/outlined/RemoveOutlined.es.js';
import '../../../../assets/icons/generated/outlined/RepeatOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ReplaceOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ReplyOutlined.es.js';
import '../../../../assets/icons/generated/outlined/SearchOutlined.es.js';
import '../../../../assets/icons/generated/outlined/SendFileToOutlined.es.js';
import '../../../../assets/icons/generated/outlined/SharingOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ShowOutlined.es.js';
import '../../../../assets/icons/generated/outlined/SidebarOutlined.es.js';
import '../../../../assets/icons/generated/outlined/SliderOutlined.es.js';
import '../../../../assets/icons/generated/outlined/SoundOutlined.es.js';
import '../../../../assets/icons/generated/outlined/StarOutlined.es.js';
import '../../../../assets/icons/generated/outlined/StemsOutlined.es.js';
import '../../../../assets/icons/generated/outlined/StoreOutlined.es.js';
import '../../../../assets/icons/generated/outlined/SuccessOutlined.es.js';
import '../../../../assets/icons/generated/outlined/SunOutlined.es.js';
import '../../../../assets/icons/generated/outlined/ThreadOutlined.es.js';
import '../../../../assets/icons/generated/outlined/TiktokOutlined.es.js';
import '../../../../assets/icons/generated/outlined/TrashOutlined.es.js';
import '../../../../assets/icons/generated/outlined/TrendingUpOutlined.es.js';
import '../../../../assets/icons/generated/outlined/UpDownOutlined.es.js';
import '../../../../assets/icons/generated/outlined/UploadOutlined.es.js';
import '../../../../assets/icons/generated/outlined/UserMessageOutlined.es.js';
import '../../../../assets/icons/generated/outlined/UserOutlined.es.js';
import '../../../../assets/icons/generated/outlined/UserPlusOutlined.es.js';
import '../../../../assets/icons/generated/outlined/UsersOutlined.es.js';
import '../../../../assets/icons/generated/outlined/VideoChatOutlined.es.js';
import '../../../../assets/icons/generated/outlined/VideoOffOutlined.es.js';
import '../../../../assets/icons/generated/outlined/VideoOnOutlined.es.js';
import '../../../../assets/icons/generated/outlined/VideoOutlined.es.js';
import '../../../../assets/icons/generated/outlined/VideoRecordingOutlined.es.js';
import '../../../../assets/icons/generated/outlined/VideoSquareOutlined.es.js';
import '../../../../assets/icons/generated/outlined/WarningOutlined.es.js';
import '../../../../assets/icons/generated/outlined/WaveformMirrorOutlined.es.js';
import '../../../../assets/icons/generated/products/Blog.es.js';
import '../../../../assets/icons/generated/products/ChromaticDark.es.js';
import '../../../../assets/icons/generated/products/Chromatic.es.js';
import '../../../../assets/icons/generated/products/CommunityChannels.es.js';
import '../../../../assets/icons/generated/products/Courses.es.js';
import '../../../../assets/icons/generated/products/Creator.es.js';
import '../../../../assets/icons/generated/products/Distribution.es.js';
import '../../../../assets/icons/generated/products/Insider.es.js';
import '../../../../assets/icons/generated/products/LandrFx.es.js';
import '../../../../assets/icons/generated/products/Mastering.es.js';
import '../../../../assets/icons/generated/products/NetworkPro.es.js';
import '../../../../assets/icons/generated/products/NetworkServices.es.js';
import '../../../../assets/icons/generated/products/Network.es.js';
import '../../../../assets/icons/generated/products/Plugins.es.js';
import '../../../../assets/icons/generated/products/ProjectsBlue.es.js';
import '../../../../assets/icons/generated/products/ProjectsRed.es.js';
import '../../../../assets/icons/generated/products/SamplesDark.es.js';
import '../../../../assets/icons/generated/products/Samples.es.js';
import '../../../../assets/icons/generated/products/SessionsDark.es.js';
import '../../../../assets/icons/generated/products/Sessions.es.js';
import '../../../../assets/icons/generated/products/Tutorials.es.js';
import '../../../../assets/icons/generated/products/Vocalign.es.js';
import { AutocompleteDropdownProvider } from '../shared/AutocompleteContext.es.js';
import { Dropdown } from '../shared/Dropdown.es.js';
import { Item } from '../shared/Item.es.js';
import { Items } from '../shared/Items.es.js';
import { NoResults } from '../shared/NoResults.es.js';
import { forwardRef } from '../../../../system/forwardRef.es.js';
import '../../../../utils/assertions.es.js';
import { runIfFn } from '../../../../utils/functions.es.js';
import '../../../../utils/responsive.es.js';
import '../../../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../../../utils/useEnhancedEffect.es.js';
import 'react-is';
import 'body-scroll-lock';
import '../../../../hooks/useNotification/useNotification.es.js';
import '../../../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import 'react-beautiful-dnd';
import { useControlled } from '../../../../hooks/useControlled/useControlled.es.js';
import 'nanoid/non-secure';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var defaultGetItemsLabel = function defaultGetItemsLabel(item) {
  return item;
};

var ComboBox = forwardRef(function (props, ref) {
  var _a = props,
      _a$items = _a.items,
      items = _a$items === void 0 ? [] : _a$items,
      _a$getItemsLabel = _a.getItemsLabel,
      getItemsLabel = _a$getItemsLabel === void 0 ? defaultGetItemsLabel : _a$getItemsLabel,
      shape = _a.shape,
      placeholder = _a.placeholder,
      _a$initialSelectedIte = _a.initialSelectedItem,
      initialSelectedItem = _a$initialSelectedIte === void 0 ? "" : _a$initialSelectedIte,
      selectedItemProp = _a.selectedItem,
      onChange = _a.onChange,
      inputValueProp = _a.inputValue,
      onInputValueChange = _a.onInputValueChange,
      onReset = _a.onReset,
      _a$itemComponent = _a.itemComponent,
      itemComponent = _a$itemComponent === void 0 ? Item : _a$itemComponent,
      _a$showNoResults = _a.showNoResults,
      showNoResults = _a$showNoResults === void 0 ? true : _a$showNoResults,
      _a$noResultsComponent = _a.noResultsComponent,
      NoResultsComponent = _a$noResultsComponent === void 0 ? NoResults : _a$noResultsComponent,
      _a$noResultsLabel = _a.noResultsLabel,
      noResultsLabel = _a$noResultsLabel === void 0 ? "No results match this query" : _a$noResultsLabel,
      maxResultsCount = _a.maxResultsCount,
      bottomComponent = _a.bottomComponent,
      groupBy = _a.groupBy,
      getDisabledOption = _a.getDisabledOption,
      addonLeft = _a.addonLeft,
      valueComponent = _a.valueComponent,
      onStateChange = _a.onStateChange,
      onOpen = _a.onOpen,
      onClose = _a.onClose,
      isLoading = _a.isLoading,
      loadingComponent = _a.loadingComponent,
      isDisabled = _a.isDisabled,
      dropdownProps = _a.dropdownProps,
      blurOnSelect = _a.blurOnSelect,
      rest = __objRest(_a, ["items", "getItemsLabel", "shape", "placeholder", "initialSelectedItem", "selectedItem", "onChange", "inputValue", "onInputValueChange", "onReset", "itemComponent", "showNoResults", "noResultsComponent", "noResultsLabel", "maxResultsCount", "bottomComponent", "groupBy", "getDisabledOption", "addonLeft", "valueComponent", "onStateChange", "onOpen", "onClose", "isLoading", "loadingComponent", "isDisabled", "dropdownProps", "blurOnSelect"]);

  var inputRef = useRef(null);

  var _useState = useState(null),
      comboBoxRef = _useState[0],
      setComboBoxRef = _useState[1];

  var mergedRefs = useMergeRefs([ref, setComboBoxRef]);

  var _useControlled = useControlled({
    value: inputValueProp,
    defaultValue: initialSelectedItem,
    onChange: onInputValueChange
  }),
      internalValue = _useControlled[0],
      setInternalValue = _useControlled[1];

  var _useControlled2 = useControlled({
    value: selectedItemProp,
    defaultValue: initialSelectedItem,
    onChange: onChange
  }),
      internalSelectedItem = _useControlled2[0],
      setInternalSelectedItem = _useControlled2[1];

  var sortedOptions = useMemo(function () {
    return groupBy ? items.sort(function (a, b) {
      return -groupBy(b).localeCompare(groupBy(a));
    }) : items;
  }, [groupBy, items]);

  var _useState2 = useState(sortedOptions),
      inputItems = _useState2[0],
      setInputItems = _useState2[1];

  useEffect(function () {
    setInputItems(maxResultsCount ? sortedOptions.slice(0, maxResultsCount) : sortedOptions);
  }, [maxResultsCount, sortedOptions]);
  var getFilteredItems = useCallback(function (inputValue2) {
    var filteredItems = sortedOptions.filter(function (item) {
      return getItemsLabel(item).toLowerCase().startsWith(inputValue2 == null ? void 0 : inputValue2.toLowerCase());
    });
    setInputItems(maxResultsCount ? filteredItems.slice(0, maxResultsCount) : filteredItems);
  }, [sortedOptions, maxResultsCount, getItemsLabel]);

  var handleInputValueChange = function handleInputValueChange(_ref) {
    var inputValue2 = _ref.inputValue;
    setInternalValue(inputValue2);
    getFilteredItems(inputValue2);
  };

  var handleIsOpenChange = function handleIsOpenChange(_ref2) {
    var isOpen2 = _ref2.isOpen;

    switch (isOpen2) {
      case true:
        onOpen == null ? void 0 : onOpen();
        break;

      case false:
        onClose == null ? void 0 : onClose();
        break;
    }
  };

  var handleSelectedItemChange = function handleSelectedItemChange(_ref3) {
    var selectedItem2 = _ref3.selectedItem;

    var _a2;

    setInternalSelectedItem == null ? void 0 : setInternalSelectedItem(selectedItem2);

    if (blurOnSelect) {
      (_a2 = inputRef.current) == null ? void 0 : _a2.blur();
    }
  };

  var _useCombobox = useCombobox({
    items: inputItems,
    inputValue: internalValue,
    onStateChange: onStateChange,
    onInputValueChange: handleInputValueChange,
    itemToString: getItemsLabel,
    onIsOpenChange: handleIsOpenChange,
    selectedItem: internalSelectedItem,
    onSelectedItemChange: handleSelectedItemChange
  }),
      isOpen = _useCombobox.isOpen,
      inputValue = _useCombobox.inputValue,
      getInputProps = _useCombobox.getInputProps,
      getItemProps = _useCombobox.getItemProps,
      getMenuProps = _useCombobox.getMenuProps,
      getToggleButtonProps = _useCombobox.getToggleButtonProps,
      highlightedIndex = _useCombobox.highlightedIndex,
      openMenu = _useCombobox.openMenu,
      closeMenu = _useCombobox.closeMenu,
      toggleMenu = _useCombobox.toggleMenu,
      selectedItem = _useCombobox.selectedItem,
      reset = _useCombobox.reset;

  var handleReset = function handleReset(event) {
    event.stopPropagation();
    onReset == null ? void 0 : onReset();
    reset();
  };

  var handleOpenMenu = function handleOpenMenu() {
    if (isDisabled) {
      return;
    } else {
      openMenu();
    }
  };

  return (
    /* @__PURE__ */
    React.createElement(AutocompleteDropdownProvider, {
      value: {
        isOpen: isOpen,
        items: inputItems,
        inputValue: inputValue,
        closeMenu: closeMenu,
        groupBy: groupBy,
        getDisabledOption: getDisabledOption
      }
    },
    /* @__PURE__ */
    React.createElement(Input, __spreadValues(__spreadValues({
      placeholder: placeholder,
      shape: shape,
      isDisabled: isDisabled,
      addonLeft: [addonLeft, !!selectedItem && runIfFn(valueComponent, selectedItem)],
      wrapperProps: {
        ref: mergedRefs,
        onClick: handleOpenMenu
      },
      addonRight: [inputValue &&
      /* @__PURE__ */
      React.createElement(IconButton, {
        key: "clear-button",
        size: "sm",
        variant: "subtle",
        isRounded: shape === "rounded",
        label: "",
        hideTooltip: true,
        icon: CloseOutlined,
        mr: "xxs",
        onClick: handleReset
      }),
      /* @__PURE__ */
      React.createElement(IconButton, __spreadValues({
        isDisabled: isDisabled,
        key: "toggle-button",
        size: "sm",
        variant: "subtle",
        isRounded: shape === "rounded",
        label: "",
        hideTooltip: true,
        icon: CaretDownOutlined,
        mr: "xxs"
      }, getToggleButtonProps({
        onClick: toggleMenu
      })))]
    }, getInputProps({
      onFocus: function onFocus() {
        if (!isOpen) {
          handleOpenMenu();
        }
      }
    })), rest)),
    /* @__PURE__ */
    React.createElement(Dropdown, {
      anchorRef: comboBoxRef,
      maxHeight: dropdownProps == null ? void 0 : dropdownProps.maxHeight
    },
    /* @__PURE__ */
    React.createElement(Items, __spreadValues({
      itemComponent: itemComponent,
      itemProps: getItemProps,
      getItemsLabel: getItemsLabel,
      showNoResults: showNoResults,
      noResultsComponent: NoResultsComponent,
      noResultsLabel: noResultsLabel,
      highlightedIndex: highlightedIndex,
      isLoading: isLoading,
      loadingComponent: loadingComponent,
      bottomComponent: bottomComponent
    }, getMenuProps({}, {
      suppressRefError: true
    })))))
  );
});
export { ComboBox };